export const CNAME_MIN_LENGTH = 3;
export const CNAME_MAX_LENGTH = 40;
export const CNAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
export const CNAME_DEBOUNCE_IN_MS = 600;
export const CNAME_MAX_AVAILABILITY_ATTEMPTS = 5;
export const CNAME_FALLBACK_PREFIX = 'sav';
export const COMPANY_NAME_DEBOUNCE_IN_MS = 600;

export const UPSERT_SALES_LEAD_RESULT = {
  SUCCESS: 'success',
  INVALID_EMAIL: 'invalidEmail',
  INVALID_WEBSITE: 'invalidWebsite',
  ERROR: 'error',
} as const;

export type UpsertSalesLeadResult =
  (typeof UPSERT_SALES_LEAD_RESULT)[keyof typeof UPSERT_SALES_LEAD_RESULT];

export const INVALID_WEBSITE_ERROR_MESSAGE_PATTERN = /^Website can't be/i;
export const WEBSITE_ERROR_FIELD = 'website';
